export default {
    methods: {
        /**
         * Überprüft rekursiv ob required Felder leer sind
         * @param {Object} obj - Das zu überprüfende Objekt
         * @returns {boolean} - true wenn required Felder fehlen
         */
        checkValues(obj) {
            let emptyRequiredFields = false;

            for (let key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    const value = obj[key];

                    if (value && value.required === true && !value.value) {
                        emptyRequiredFields = true;
                        break;
                    }

                    if (typeof value === "object" && !Array.isArray(value)) {
                        const nestedCheck = this.checkValues(value);
                        if (nestedCheck) {
                            emptyRequiredFields = true;
                            break;
                        }
                    }
                }
            }

            return emptyRequiredFields;
        },

        /**
         * KISS: Scrollt zum ersten sichtbaren Element mit Error-State
         * Wird über EventBus aufgerufen, funktioniert von überall
         */
        scrollToFirstEmptyField() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const errorSelectors = [
                        '.dt-input.error',
                        '.dt-select.error', 
                        '.dt-color-radio.error',
                        '.auto-profile-ai.error',
                        '.autoprofile2 .image-preview-wrapper.error',
                        '.dt-date-input.error'
                    ];
                    
                    const errorElements = document.querySelectorAll(errorSelectors.join(', '));
                    
                    if (errorElements.length > 0) {
                        const firstErrorElement = errorElements[0];
                        
                        firstErrorElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                        
                    }
                }, 100);
            });
        }
    }
}; 
